// Declarative schedule for Turbo's seasonal accessories. Ten moments
// across the year, six fixed-date and one moveable (Easter). The
// resolver (useSeasonalAccessory) walks this list, picks every
// season currently active for the supplied date, and returns the
// highest-priority match.
//
// Priorities exist so overlapping windows pick a clear winner:
//   90 — anchored moments (Christmas, New Year, Halloween, etc.)
//   50 — vibe seasons (Winter, Spring, Summer, Autumn)
// Easter sits at 90 so it wins over Spring (50) on years where the
// windows happen to overlap (Easter is moveable, Spring is fixed).
//
// Cross-year ranges (New Year spans Dec 31 → Jan 10) are handled in
// the resolver's isActive() check — flagged via startMMDD > endMMDD.
//
// Components are lazy-imported via the Component prop so each season
// can be code-split later if bundle size becomes an issue. v1 imports
// all of them up-front for simplicity.

import { easterWindow } from './easter';
import ChristmasAccessory from './accessories/ChristmasAccessory';
import NewYearAccessory from './accessories/NewYearAccessory';
import WinterAccessory from './accessories/WinterAccessory';
import ValentinesAccessory from './accessories/ValentinesAccessory';
import SpringAccessory from './accessories/SpringAccessory';
import EasterAccessory from './accessories/EasterAccessory';
import SummerAccessory from './accessories/SummerAccessory';
import AutumnAccessory from './accessories/AutumnAccessory';
import HalloweenAccessory from './accessories/HalloweenAccessory';
import BonfireAccessory from './accessories/BonfireAccessory';

export const SEASONAL_ACCESSORIES = [
  {
    id: 'newyear',
    displayName: 'New Year',
    Component: NewYearAccessory,
    priority: 90,
    startMMDD: '12-31',
    endMMDD: '01-10', // crosses year boundary
  },
  {
    id: 'winter',
    displayName: 'Winter',
    Component: WinterAccessory,
    priority: 50,
    startMMDD: '01-11',
    endMMDD: '01-22',
  },
  {
    id: 'valentines',
    displayName: "Valentine's",
    Component: ValentinesAccessory,
    priority: 80,
    startMMDD: '02-09',
    endMMDD: '02-15',
  },
  {
    id: 'spring',
    displayName: 'Spring',
    Component: SpringAccessory,
    priority: 50,
    startMMDD: '03-14',
    endMMDD: '03-28',
  },
  {
    id: 'easter',
    displayName: 'Easter',
    Component: EasterAccessory,
    priority: 90,
    computeDates: easterWindow,
  },
  {
    id: 'summer',
    displayName: 'Summer',
    Component: SummerAccessory,
    priority: 50,
    startMMDD: '07-20',
    endMMDD: '08-03',
  },
  {
    id: 'autumn',
    displayName: 'Autumn',
    Component: AutumnAccessory,
    priority: 50,
    startMMDD: '09-22',
    endMMDD: '10-06',
  },
  {
    id: 'halloween',
    displayName: 'Halloween',
    Component: HalloweenAccessory,
    priority: 90,
    startMMDD: '10-25',
    endMMDD: '10-31',
  },
  {
    id: 'bonfire',
    displayName: 'Bonfire Night',
    Component: BonfireAccessory,
    priority: 90,
    startMMDD: '11-04',
    endMMDD: '11-06',
  },
  {
    id: 'christmas',
    displayName: 'Christmas',
    Component: ChristmasAccessory,
    priority: 90,
    startMMDD: '12-10',
    endMMDD: '12-26',
  },
];
